<template>
    <div class="detail-box">
        <div class="detail-header HeaderBar Headerbg" :class='{active:active,scrool:scrool}'>
            <div class="detail-header-main" @click="changeSidebar()">
                <i v-show="!main" class="iconfont x-a-maenbtn"></i>
                <i v-show="main" class="iconfont x-a-maenbtnx"></i>
            </div>
            <div class="detail-header-logo">
                <img v-show="zhactive" @click="changeIndex()"  src="@/assets/images/index-svg-black.svg" alt="">
                <img v-show="enactive" @click="changeIndex()"  src="@/assets/images/index-svg-black-en.svg" alt="">
            </div>
            <div class="detail-header-En">
                <span  v-show="skill" >技术支持</span>
                <span class="spancolor" :class='{spanactive:zhactive}' @click="setLanguage('zh')">中文</span>
                <span> <el-divider direction="vertical"></el-divider></span>
                <span class="spancolor" :class='{spanactive:enactive}' @click="setLanguage('en')">EN</span>
            </div>
        </div>
        <div class="detail-aside AsideBar" :class="{AsideBaractive:mianOpen}">
            <div class="HeaderI"></div>
            <div class="Sider">
                <ul class="Sider-ul">
                    <li class="Sider-ul-li" v-for="(item,i) in list" :class="{active:item.active}" :key='i' @click="tochangeli(item)">
                        <span class="spanul">{{$t(item.name)}}</span> &nbsp;<span v-show="i ==1"></span>
                        <ul :class='{active:item.show===true}'  :ref="`list${i}`">
                            <li v-for="(a,index) in item.list" :key="index" @click.stop="doThis(a)">
                                <span v-show="zhactive" class="spanli">{{a.name}}</span>
                                <span v-show="enactive" class="spanli">{{a.name_en}}</span>
                            </li>
                        </ul>
                    </li>
                </ul> 
            </div>
            <div class="AsideBar-bottom">      
                <span class="spancolor" :class='{spanactive:zhactive}' @click="setLanguage('zh')">中文</span>
                <span class="spancolor" :class='{spanactive:enactive}' @click="setLanguage('en')">EN</span>
            </div>
        </div>
        <div class="Center">
            <div class="HeaderI"></div>
            <div class="Center-box">
                <div class="Center-box-left">
                    <div class="Sider">
                        <ul class="Sider-ul">
                            <li class="Sider-ul-li" v-for="(item,i) in list" :key='i' :class="{active:item.active}"  @click="tochangeli(item)">
                                <span class="spanul">{{$t(item.name)}}</span> &nbsp;<span class="spanul2" v-show="i ==1"></span>
                                <ul :class='{active:item.show===true}'  :ref="`listlg${i}`">
                                    <li v-for="(a,index) in item.list" :key="index" @click.stop="doThis(a)">
                                         <span v-show="zhactive" class="spanli">{{a.name}}</span>
                                        <span v-show="enactive" class="spanli">{{a.name_en}}</span>
                                    </li>
                                </ul>
                            </li>
                        </ul> 
                    </div>
                </div>
                <div class="Center-box-right">
                    <div class="detail-center">
                        <div class="detail-center-top" :class="{detailcenter:detailcenter}">
                             <div class="detail-center-top-img">
                                 <img :src="storycover" alt="">
                             </div>
                        </div>
                        <div class="detail-center-bottom" :class="{detailcenter:detailcenter}">
                            <div class="detail-center-bottomBox">
                                <div class="detail-center-bottomBox-header">
                                    <span><i class="iconfont cs-shuxian"></i></span>{{storytitle}}</div>
                                <div class="detail-center-bottomBox-text" v-html="storycontent"></div>
                            </div>
                        </div>
                    </div>
                    <div class="common-width">
                       <div class="Bottom">
                           <div class="Bottom-list">
                                <div  v-for="(item,i) in icons" :key="i" @click="iconto(i)" @mouseenter="mouseEnter(i)" @mouseleave="mouseLeave(i)">
                                    <a href="javascript:;">
                                        <i class="derail-center-right-mean-i" :class="'iconfont'+ ` ${item}`">
                                            <div class="box-Bottom" :class="{bottomLi:i == idxi && i==0}" >
                                                <div class="Triangle-down"></div>
                                                 <img v-show="zhactive" src="@/assets/images/werther-zh.jpg" alt="">
                                                <img v-show="enactive" src="@/assets/images/werther-en.jpg" alt="">
                                            </div>
                                        </i>
                                    </a>
                                </div>
                                 <!-- <share :config='config'></share> -->
                           </div>
                           <div class="Bottom-divider">
                                <el-divider></el-divider>
                           </div>
                           <div class="Bottom-icp">
                                <div><a href="javascript:;">{{$t('lang.Record_1')}}</a></div>
                                <div>&nbsp;&nbsp;&nbsp;</div>
                                <div><a href="https://beian.miit.gov.cn" target="_blank">{{$t('lang.Record_2')}}</a></div>
                           </div>
                       </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="BottomLeft">
            <div class="BottomLeft-box">
                <div class="BottomLeft-list">
                    <div  v-for="(item,i) in icons" :key="i" @click="iconto(i)" @mouseenter="mouseEnter(i)" @mouseleave="mouseLeave(i)">
                        <a href="javascript:;">
                            <i class="derail-center-right-mean-i" :class="'iconfont'+ ` ${item}`">
                                <div class="box-Bottom" :class="{bottomLi:i == idxi && i==0}" >
                                    <div class="Triangle-down"></div>
                                      <img v-show="zhactive" src="@/assets/images/werther-zh.jpg" alt="">
                                        <img v-show="enactive" src="@/assets/images/werther-en.jpg" alt="">
                                </div>
                            </i>
                        </a>
                    </div>
                     <!-- <share :config='config'></share> -->
                </div>
                <div class="BottomLeft-icp">
                    <div><a href="javascript:;">{{$t('lang.Record_1')}}</a></div>
                    <div>&nbsp;&nbsp;&nbsp;</div>
                    <div><a href="https://beian.miit.gov.cn" target="_blank">{{$t('lang.Record_2')}}</a></div>
                </div>
            </div>
        </div>
        <div class="all-center" :class="{openicon:openicon}">
            <div class="all-center-box" @click="changeiconto"></div>
            <img v-show="zhactive" src="@/assets/images/werther-zh.jpg" alt="">
            <img v-show="enactive" src="@/assets/images/werther-en.jpg" alt="">
        </div>
    </div>
</template>
<script>
import { product,brandstory } from "@/api/index";
import {mapGetters} from "vuex"
import {Localurl} from "@/utils/validate"
export default {
    name:'detail',
    computed:{
        ...mapGetters(["languageType"])
    },
    components:{
    },
    data(){
        return{
            idxi:-1,
            zhactive:true,
            enactive:false,
            main:false,
            mianOpen:false,
            active:false,
            skill:false,
            headerbarlistactive:true,
            detailcenter:false,
            openicon:false,
            scrool:false,
            icons:['x-wechat','x-jd','x-tm'],
            list:[ 
                {name:'lang.index_li1',url:{name:'/detail',open:true},list:[],show:false,active:true},
                {name:'lang.index_li2',url:{name:'/list',open:false},list:[],show:false,active:false},
                {name:'lang.index_li3',url:{name:'/about',open:true},list:[],show:false,active:false},
                {name:'lang.index_li4',url:{name:'/position',open:true},list:[],show:false,active:false},
                {name:'lang.index_li5',url:{name:'/callus',open:true},list:[],show:false,active:false},
            ],
            mainliHeight:40,
            config:{
                sites:['qq','wechat','linkedin','facebook','twitter'],
            },
            storytitle:'',
            storycover:'',
            brandstorylist:'',
            storycontent:''
            
        }
    },
    mounted(){
        setTimeout(()=>{
            this.active=true
            this.getWidth();
            this.openicon=false;
            this.setLanguage(this.languageType)
            Localurl("?lang="+this.languageType);
        },500)
    },

    methods:{
        changeSidebar(){
            this.main = !this.main
            this.mianOpen = !this.mianOpen
        },
        changeIndex(){this.$router.push({path:'/index',query:{lang:this.languageType}})},
        getWidth(){
            if( window.innerWidth < 992 && this.headerbarlistactive){
                this.headerbarlistactive = false
                this.detailcenter= true
            }
            if( window.innerWidth >= 992 && !this.headerbarlistactive){
                this.headerbarlistactive = true
                this.detailcenter= false
                this.main=false
                this.mianOpen=false
            }
            if( window.innerWidth >= 468 && !this.headerbarlistactive){
                this.openicon=false
            }
        },
        tochangeli(item){
            if(this.$route.path == item.url.name){return;}
            if(item.url.open){this.$router.push(item.url.name);}
            if(!item.url.open){this.$router.push({path:item.url.name,query:{id:item.list[0].id}});}
        },
        // leaveli(index){
            
        //     this.$refs[`list${index}`][0].style.height = '0'
        //     this.$refs[`listlg${index}`][0].style.height = '0'
        // },
        // enterli(item,index){
        //     this.list.map((i,mapidx)=>{
        //         if(item.show !== i.show){
        //             i.show = false 
        //             this.$refs[`list${mapidx}`][0].style.height = '0'
        //              this.$refs[`listlg${mapidx}`][0].style.height = '0'
        //         }
        //     })
        //     item.show = !item.show;
        //     this.$refs[`list${index}`][0].style.height =this.list[index].list.length * this.mainliHeight +'px';
        //     this.$refs[`listlg${index}`][0].style.height =this.list[index].list.length * this.mainliHeight +'px';
        // },
        doThis(item){
             if(item.open){this.$router.push({path:item.namelink,query:{id:item.id}});}
        },
        setLanguage(val){
            this.$store.dispatch("index/language",{lang:val})
            Localurl("?lang="+this.languageType);
            this.$i18n.locale = val
            if(val == 'zh'){
                this.zhactive = true
                this.enactive = false
                this.storytitle = this.brandstorylist.title
                this.storycover = this.brandstorylist.cover
                this.storycontent = this.brandstorylist.content
                this.storycover = this.brandstorylist.cover
                document.title = "品牌故事"
            }else{
                this.enactive = true
                this.zhactive = false
                this.storytitle =this.brandstorylist.title_en
                this.storycover =this.brandstorylist.cover_en
                this.storycontent =this.brandstorylist.content_en
                this.storycover = this.brandstorylist.cover_en
                document.title = "BRAND STORY"
            }
        },
        mouseEnter(i) {this.idxi =i},
        mouseLeave() {this.idxi =-1},
        iconto(i){
            if(i===0 && !this.headerbarlistactive){this.openicon=true}
            if(i===1){window.open("https://mall.jd.com/index-12191261.html","_black")}
            if(i===2){window.open("https://x-speaker.tmall.com/?spm=a217wi.openworkbeanchtmall.widgets.2.41e65e16MbeHsw","_black")}
        },
        changeiconto(){this.openicon=false},
        setBrandstory(obj){
            this.brandstorylist = obj; 
            this.setLanguage(this.$i18n.locale);
        },
        fetchData(){
            var that =this
            product({pageSize:20}).then((res) => {
               
                if(res.code == 200){
                    var data = res.data.list;
                    for(var i=0;i<data.length;i++){
                        this.list[1].list.push({
                            name:data[i].name,
                            name_en:data[i].name_en,
                            id:data[i].id,
                            namelink:'/list',
                            open:true,
                        })
                    }
                }
            })

            brandstory().then((res)=>{
                if(res.code == 200){
                    var data =res.data;
                    that.setBrandstory(data);
                }
               
            })
            
        },
        handleScroll(){
            if(window.pageYOffset>20){
                this.scrool=true
              
            }else{
                this.scrool=false
            }
        },
        
    },
    created(){
        this.fetchData();
        document.addEventListener('scroll',this.handleScroll);
        window.addEventListener('resize', this.getWidth);
    },
    beforeDestroy(){
        document.removeEventListener('scroll',this.handleScroll);
        window.removeEventListener('resize', this.getWidth); 
    },
}
</script>
<style>
.detail-center{
    /* position: relative; */
    /* height: 800px; */
    display: flex;
    flex-direction: column;
}
.detail-center-top,.detail-center-bottom{
    /* position: absolute;left: 0; width: 100%;transition: .3s ease-in-out */
    }
.detail-center-top{top: 0;height: 620px;order: 1;}
.detail-center-bottom{order: 2}
/* .detail-center-top.detailcenter{top: 30%;height: 70%;} */
/* .detail-center-bottom.detailcenter{top: 0;height: 30%;} */
.detail-center-top-img{
    width: 100%;height: 100%;
}
.detail-center-top-img img{
        object-fit: cover;
    width: 100%;height: 100%;
    /* background-size: 2880px 1620px ;
    overflow: hidden;
    background-position: center center;
    background-repeat: no-repeat;
    background-image: url('../../assets/images/pian.jpg'); */
}
.detail-center-bottomBox{
    padding: 20px;
    overflow: hidden;
}
.detail-center-bottomBox-header{
    padding: 30px 0 30px 20px;
    line-height: 30px;
    font-size: 24px;
    color: #202020;
}
.detail-center-bottomBox-header span i{font-size: 24px;}
.detail-center-bottomBox-text{width: 60%;padding: 0 30px;color: #333}
.detail-header-main i{ display: none}

.detail-center-top{
    padding: 0 0 0 50px
}
@media (max-width: 1200px){
    .detail-center-bottomBox-text{width: 80%;}
}
@media (max-width: 992px){
    .Center-box-left{display: none}
    .detail-center-bottomBox-text{width: 100%;}
    .detail-center-bottomBox{padding: 0px}
    .detail-header-main i{ display: block}
    .detail-header-En span{display: none}
    .detail-center-top{padding:0;height: 400px;}
    .detail-center-top{top: 0;height: 500px;order: 2}
    .detail-center-bottom{order: 1;margin-bottom: 40px;}
}
@media (max-width: 468px){
    .detail-center-bottomBox-text{
        font-size: 14px;
    }
    .detail-center-top{padding:0;height: 300px;}
    /* .detail-aside{
        width: 50%;
        left: -300px;
    } */
    .detail-header-main i{display: block}
}
.el-divider--horizontal{
    margin: 20px 0;
}
</style>
